import { createSlice } from '@reduxjs/toolkit'
import { getUserData } from '../../utils/localStorage'

const INIT_STATE = {
  user: getUserData().user || false, // default is false, (|| true) should be changed to false
  token: getUserData().token || null,
  user_role: getUserData().user_role || null,
  userData: getUserData().userData || {},
}

export const auth = createSlice({
  name: 'auth',
  initialState: INIT_STATE,
  reducers: {
    userSignIn: (state, { payload }) => ({
      ...state,
      user: payload.user,
      token: payload.token,
      userData: payload.data,
      user_role: payload.user_role,
    }),
    userSignOut: (state) => ({
      ...state,
      user: false,
      token: null,
      user_role: null,
      userData: {},
    }),
    userData: (state, { payload }) => ({
      ...state,
      userData: payload,
    }),
  },
})

export const { userSignIn, userSignOut, userData } = auth.actions
export default auth.reducer
